import { DOCUMENT } from '@angular/common';
import { Injectable, ElementRef, Renderer2, Inject, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  sections!: ElementRef[]
  indexPosition = 0
  scrollPosition = 0
  private renderer: Renderer2;

  sectionIndex: number = 0;

  scrollingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  scrolling$: Observable<boolean> = this.scrollingSubject.asObservable();

  constructor(private rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadSections(objects: ElementRef[]){
    this.sections = objects;
  }


  setScrollIndex(index: number): void {
    // this.indexPositionSubject.next(index)
    this.indexPosition = index;
  }

  setScrollPosition(position: number): void {
    this.scrollPosition = position;
    // this.scrollPositionSubject.next(position)
  }

  getScrollPosition(): number {
    return this.scrollPosition;
  }

  getScrollIndex(): number {
    return this.indexPosition;
  }


  //Abilita o scroll da pagina
  enableScroll(){
    this.renderer.removeStyle(this.document.body, 'overflow');
  }

  //Desabilita o scroll da pagina
  disableScroll(){
    this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
  }

}
